import { ActionCreatorWithPayload, createAction, Dispatch } from '@reduxjs/toolkit';
import * as Actions from './types';

/**
 * @desc Set task loader
 */
export const setTaskLoader: ActionCreatorWithPayload<boolean, string> = createAction(Actions.SET_TASK_LOADER);

/**
 * @desc Clear tasks Data
 */
export const clearProjectTasksData = () => (dispatch: Dispatch) => {
  dispatch(setTaskLoader(false));
};
